import React, { useEffect, useState } from 'react';
import { Box, Typography, Radio, RadioGroup, FormControlLabel, Grid2 } from '@mui/material';
import Heading, { ImgText } from '../../shared/utils/Heading';
import CustomDivider from '../../shared/utils/CustomDivider';
import { Constants, Page_Padding } from '../../shared/constants';
import Apartment from './Apartment';
import PreSchool from './PreSchool';
import Individual from './Individual';
import useContactStore from '../../shared/store/contactStore';
import { useLocation } from 'react-router-dom';

const optionsList = [
    { label: "Apartment", value: "Apartment" },
    { label: "School", value: "School" },
    { label: "Individual", value: "Individual" },
];

const ApartmentOnboarding = () => {
    const location = useLocation();
    const defaultOption = location.state?.selected || "Apartment";

    const [selectedOption, setSelectedOption] = useState(defaultOption);
    // const [selectedOption, setSelectedOption] = useState(optionsList[0].value); // Default to first option
    const { resetContactPersons } = useContactStore();

    useEffect(() => {
        resetContactPersons();
    }, [selectedOption, resetContactPersons]);

    const renderSelectedComponent = () => {
        switch (selectedOption) {
            case "Apartment":
                return <Apartment />;
            case "School":
                return <PreSchool />;
            case "Individual":
                return <Individual />;
            default:
                return null;
        }
    };

    return (
        <Box className="body apartment_onboarding" px={Page_Padding}>
            {/* <Box>
                <Box sx={{
                    backgroundImage: `url(${Constants.customImages.ApartmentOnboaFram})`,
                    backgroundSize: { xs: "100% auto", md: "70% auto" },
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "250px",
                    gap: 2
                }}>
                    <ImgText text={"How would you like to on-board yourself ?"} sx={{ fontSize: { xs: "15px", sm: "30px" } }} />
                    <RadioGroup
                        row
                        value={selectedOption}
                        onChange={(e) => setSelectedOption(e.target.value)}
                    >
                        {optionsList.map(option => {
                            return (
                                <FormControlLabel
                                    key={option.value}
                                    value={option.value}
                                    control={
                                        <Radio
                                            sx={{
                                                color: "#DC143C",
                                                '&.Mui-checked': {
                                                    color: "#DC143C",
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography variant='body2' fontSize={{ xs: "10px", sm: "16px" }}>{option.label}</Typography>}

                                />
                            );
                        })}
                    </RadioGroup>

                </Box>
            </Box> */}
            {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box component={"img"} src={Constants.customImages.QuestionLady} sx={{
                    width: '120px',
                    transform: "translate(20px, -30px)"
                }} />
            </Box> 
            <CustomDivider orientation='horizontal' />
            */}
            <Heading
                Heading="Discover the key benefits that make this experience smarter"
                SubHeading="Why You’ll Love It!!!"

            />
            {/* <Box
                sx={{
                    position: "relative",
                    backgroundImage: `url(${Constants.customImages.ApartmentConnect})`,
                    backgroundSize: "100% auto",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    overflow: "hidden",
                    minHeight: "80vh",
                }}
            >
                <Grid2 container height={"30%"}>
                    <Grid2 children size={5} />
                    <Grid2 children size={3}>
                        <Typography variant='body2' color='#DC143C'>Nurturing Young Minds</Typography>
                        <Typography variant='body2'>Cultivate a love for learning and exploration, setting them up for future success</Typography>

                    </Grid2>


                </Grid2>
                <Grid2 container height={"40%"}>
                    <Grid2 children size={2.5} />
                    <Grid2 children size={3}>
                        <Typography variant='body2' color='#59C7D2'>No Commute Hassle</Typography>
                        <Typography variant='body2'>Save time and resources, focus on what matters most</Typography>

                    </Grid2>
                    <Grid2 children size={3.5} />
                    <Grid2 children size={3}
                        sx={{
                            transform: "translateY(30px)", // move it upward
                        }}
                    >
                        <Typography variant='body2' color='#87CEEB'>Empowering Parents</Typography>
                        <Typography variant='body2'>Provide the best opportunities for your kids, without worrying about travel</Typography>

                    </Grid2>

                </Grid2>

                <Grid2 container height={"30%"}>
                    <Grid2 size={1.2} />

                    <Grid2 size={3.5}>
                        <Typography variant='body2' color="#FAC584">Safe & Convenient</Typography>
                        <Typography variant='body2'>
                            Kids learn from highly skilled trainers from the comfort of home
                        </Typography>
                    </Grid2>

                    <Grid2 size={2.5} />

                    <Grid2
                        size={3.5}
                        sx={{
                            transform: "translateY(-50px)", // move it upward
                        }}
                    >
                        <Typography variant='body2' color='#B235E6'>Building Friendships</Typography>
                        <Typography variant='body2'>
                            Kids make new connections, promoting harmony amongst residents
                        </Typography>
                    </Grid2>

                    <Grid2 size={0.5} />
                </Grid2>



            </Box>
            <CustomDivider orientation='horizontal' />
            <Heading
                Heading="Get settled in smoothly with our step-by-step  On Boarding guide"
                SubHeading="Welcome to Your New Home! "
            /> */}

            {/* <CustomDivider orientation='horizontal' /> */}
            {/* {renderSelectedComponent()} */}
            <Apartment />
        </Box>
    );
};

export default ApartmentOnboarding;
